<template>
    <div v-if="!loading && !isLoading" class="tpl-filter">
        <BmvSelect
            v-model="filterForm"
            :options="forms"
            :multiple="true"
            :searchable="true"
            label-key="name"
            track-by="id"
            :placeholder="$t('post.page.postsfilters.form')"
            :no-result-text="$t('post.page.postsfilters.noresult')"
            @input="onFilterChangeMultiSelect('form_id', filterForm, true)"
        />
    </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import BmvSelect from '@/components/UI/BmvSelect.vue'

export default {
    name: 'TemplatesFilters',
    props: ['isLoading'],
    components: {
        BmvSelect
    },
    data() {
        return {
            value: '',
            filterForm: [],
            loading: true,
            setSelectedTemplate: {},
            filters: {},
            currentFilter: {}
        }
    },
    computed: {
        ...mapState('admin', {
            config: (state) => state.templatesConfig,
            template: (state) => state.template
        }),
        ...mapState('form', {
            forms: (state) => state.forms
        })
    },
    created() {
        this.getForms().then(() => {
            this.loading = false
        })
    },
    methods: {
        ...mapActions('admin', ['getTemplates', 'getTemplate']),
        ...mapActions('form', ['getForms']),
        getFilters() {
            this.getTemplatesFilters().catch((e) => {
                this.$store.dispatch('dispatchError', e)
            })
        },
        onFilterChangeMultiSelect(element, filter, change) {

          if (filter.length) {

            var transformedFilter = Array()
                for (let i = 0; i < filter.length; i++) {
                    transformedFilter[i] = filter[i].id
                }
                filter = {
                    [element]: transformedFilter.toString()
                }
            } else {
                filter = {
                    [element]: filter.id
                }
            }
            if (change) {
              this.onFilterChange(filter)
            } else {
                return filter
            }
        },
        onFilterChange(currentFilter) {
          Object.keys(currentFilter).forEach((element) => {
                this.filters[element] = currentFilter[element]
            })
            this.config.per_page = 15
            this.config.page = 1
            this.config.filters = this.filters
          this.$emit('load-data')
        },
    }
}
</script>

<style scoped>
.tpl-filter {
    flex: 1;
    min-width: 0;
}

@media (max-width: 992px) {
    .tpl-filter {
        min-width: auto;
        width: 100%;
    }
}

@media (max-width: 576px) {
    .tpl-filter {
        flex-direction: column;
        align-items: stretch;
        gap: 6px;
    }
}
</style>

